var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmpowerment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3489",
    "data-name": "Group 3489",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.299,
    height: 50,
    viewBox: "0 0 53.299 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2263",
    "data-name": "Rectangle 2263",
    width: 53.299,
    height: 50,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3488",
    "data-name": "Group 3488",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5615",
    "data-name": "Path 5615",
    d: "M107.4,189.423c2.2-.664,4.32-1.152,5.3-3.366.364-.824.682-.188,1.023.083a3.606,3.606,0,0,0,5.022-.121c.314-.26.47-.825,1.088-.274,1.825,1.628,3.7,1.348,5.677-.346a20.569,20.569,0,0,1-.762,8.344c-.885,3.159-1.772,6.318-2.683,9.47a8.175,8.175,0,0,0-.43,3.231c.146,1.248-.157,1.811-1.617,1.779-4.653-.1-9.31-.069-13.965-.015-1.171.014-1.844-.173-1.659-1.546a4.9,4.9,0,0,0-.956-3.276c-1.413-2.261-2.782-4.55-4.177-6.821-2.82-4.59-2.684-8.006.5-12.451,1.817-2.533,2.763-2.9,5.747-2.13,1.519.391,3.024.84,4.532,1.276,1.912.553,2.279,1.929.8,3.271a7.329,7.329,0,0,1-4.959,1.611c-.508.014-1.23-.268-1.442.41-.255.817.585.962,1.07,1.258,3.058,1.87,5.919,3.944,7.733,7.159.215.381.367,1.045,1.006.7.712-.384.273-.92.022-1.4a17.294,17.294,0,0,0-4.928-5.427c-.579-.452-1.186-.869-1.946-1.424",
    transform: "translate(-84.723 -158.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5616",
    "data-name": "Path 5616",
    d: "M230.075,122.861c-.1,1.362-.141,2.731-.308,4.084a2.445,2.445,0,1,1-4.878-.341c.09-2.524.285-5.044.472-7.563a2.244,2.244,0,0,1,2.4-2.284,2.335,2.335,0,0,1,2.507,2.428,27.494,27.494,0,0,1-.246,3.672l.053,0",
    transform: "translate(-195.911 -101.713)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5617",
    "data-name": "Path 5617",
    d: "M273.581,137.246c.125-1.539.242-2.832.331-4.127a2.286,2.286,0,0,1,2.5-2.406,2.386,2.386,0,0,1,2.463,2.69c-.018,1.7-.2,3.409-.325,5.112-.118,1.582-.946,2.677-2.553,2.625-1.7-.055-2.521-1.174-2.417-2.907.024-.409,0-.82,0-.987",
    transform: "translate(-238.319 -113.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5618",
    "data-name": "Path 5618",
    d: "M181.329,118.828c-1.953-1.182-4.218-.781-4.919-2.077-.676-1.25-.111-3.171-.091-4.8,0-.272,0-.545.014-.817.07-2.015,1.118-3.369,2.628-3.186,1.823.22,2.431,1.439,2.384,3.188-.065,2.373-.016,4.75-.016,7.689",
    transform: "translate(-153.391 -94.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5619",
    "data-name": "Path 5619",
    d: "M126.571,124.3c0-1.8-.038-3.43.011-5.059a2.478,2.478,0,0,1,4.955-.081,4.048,4.048,0,0,1,.013.409c0,1.3.311,2.7-.077,3.865-.609,1.832-2.192-.268-3.249.46a5.642,5.642,0,0,1-1.653.405",
    transform: "translate(-110.25 -101.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5620",
    "data-name": "Path 5620",
    d: "M89.394,37.056c1,.691,1.488,1.848,2.255,2.765.395.472,1.224,1.149.569,1.675-.9.719-1.174-.475-1.588-.971a28.183,28.183,0,0,1-1.784-2.449c-.359-.54-.086-.865.548-1.02",
    transform: "translate(-77.259 -32.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5621",
    "data-name": "Path 5621",
    d: "M296.5,41.652c-.663-.064-.783-.51-.468-.975.794-1.172,1.626-2.323,2.523-3.416.381-.465.876-.329,1.056.284.132.451-2.635,4.07-3.111,4.107",
    transform: "translate(-257.742 -32.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5622",
    "data-name": "Path 5622",
    d: "M20.975,136.366c-.138.625-.492.774-1.043.573-1.2-.438-2.412-.865-3.615-1.307-.324-.119-.655-.309-.6-.706a.571.571,0,0,1,.718-.523c1.406.469,2.8.985,4.181,1.512.156.059.242.3.354.45",
    transform: "translate(-13.69 -117.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5623",
    "data-name": "Path 5623",
    d: "M362.513,134.94c-.072.146-.115.419-.245.47-1.441.565-2.889,1.112-4.353,1.611-.147.05-.472-.208-.611-.4a.46.46,0,0,1,.242-.669c1.38-.542,2.774-1.049,4.175-1.533.375-.13.614.142.793.519",
    transform: "translate(-311.199 -117.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5624",
    "data-name": "Path 5624",
    d: "M2.563,243.359c-.895-.343-2.578.507-2.564-.742.014-1.149,1.705-.587,2.626-.575.894.012,2.566-.608,2.539.639-.027,1.216-1.711.315-2.6.678",
    transform: "translate(0.001 -210.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5625",
    "data-name": "Path 5625",
    d: "M376.215,243.375c-1.007-.393-2.691.466-2.67-.8.019-1.139,1.715-.579,2.636-.559.889.019,2.572-.639,2.532.644-.04,1.3-1.756.144-2.5.717",
    transform: "translate(-325.414 -210.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5626",
    "data-name": "Path 5626",
    d: "M202.9,2.592c-.422.837.616,2.464-.748,2.492-.973.02-.462-1.621-.44-2.481.023-.913-.6-2.6.521-2.6,1.194,0,.288,1.69.667,2.592",
    transform: "translate(-175.587 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmpowerment);
export default __webpack_public_path__ + "static/media/icon-empowerment.b1044dfd4b194d3e71826b3bd785d993.svg";
export { ForwardRef as ReactComponent };